type PersonalTrailLocale = typeof import('../en/personalTrail').default

const personalTrail = {
	title: 'Mi rastro',
	subtitle: 'Lo que has marcado y anotado.',
	search: {
		placeholder: 'Buscar en mi rastro',
	},
	filters: {
		all: 'Todo',
		favorites: 'Favoritos',
		notes: 'Notas',
		content: 'Contenido',
		resources: 'Recursos',
		allPrograms:
			'Tod{{collectionEntityGenderSuffixPlural}} {{collectionEntityArticlePluralLower}} {{collectionEntityLabelPluralLower}}',
	},
	count: '{{visible}} de {{total}} elementos',
	page: 'página {{page}} de {{total}}',
	empty: {
		none: {
			title: 'Aún no has dejado rastro',
			description:
				'Marca un contenido como criterio, haz favorito un recurso o toma una nota: aparecerá aquí para reencontrarlo.',
		},
		filtered: {
			title: 'No hay elementos que coincidan',
			description:
				'Prueba con otro filtro o vuelve cuando hayas marcado contenido.',
		},
	},
	pagination: {
		previous: 'Anterior',
		next: 'Siguiente',
	},
	detail: {
		placeholder: {
			title: 'Selecciona una marca del rastro',
			description:
				'La lectura se abrirá aquí con el contexto completo del recurso, contenido o nota.',
		},
		backToIndex: 'Volver al índice',
		openInContext: 'Abrir en su contexto original',
		notesTitle: 'Notas personales',
	},
	item: {
		note: 'Nota',
	},
	labels: {
		state: {
			favorite: 'Favorito',
			note: 'Nota personal',
		},
		target: {
			content: 'Contenido',
			resource: 'Recurso',
		},
		resourceTypes: {
			video: 'Vídeo',
			book: 'Libro',
			pdf: 'PDF',
			post: 'Post',
			image: 'Imagen',
			link: 'Enlace',
			file: 'Archivo',
			model3d: 'Modelo 3D',
		},
	},
} satisfies PersonalTrailLocale

export default personalTrail
